export const appWrap = {
  maxWidth: 480,
  margin: "0 auto",
  minHeight: "100vh",
  background: "#111827",
  color: "#F9FAFB",
  fontFamily: "'Inter', sans-serif",
  paddingBottom: 80,
};

export const btnStyle = (color, small = false) => ({
  display: small ? "inline-block" : "block",
  width: small ? "auto" : "100%",
  padding: small ? "10px 20px" : "16px",
  marginBottom: small ? 0 : 10,
  backgroundColor: color,
  color: "white",
  border: "none",
  borderRadius: 12,
  fontSize: small ? 14 : 16,
  fontWeight: "700",
  cursor: "pointer",
  letterSpacing: "0.3px",
});

export const backBtn = {
  background: "none",
  border: "none",
  color: "#9CA3AF",
  fontSize: 15,
  cursor: "pointer",
  marginBottom: 16,
  padding: 0,
  display: "flex",
  alignItems: "center",
  gap: 4,
};

export const inputStyle = {
  padding: "12px 14px",
  borderRadius: 10,
  border: "1px solid #374151",
  background: "#1F2937",
  color: "#F9FAFB",
  fontSize: 16,
  width: "100%",
  boxSizing: "border-box",
  outline: "none",
};

export const labelStyle = {
  display: "block",
  fontWeight: "600",
  marginBottom: 6,
  color: "#9CA3AF",
  fontSize: 13,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

export const tabBtn = {
  flex: 1,
  padding: "10px",
  border: "none",
  borderRadius: 10,
  fontSize: 14,
  cursor: "pointer",
  fontWeight: "700",
};

export const dayBtn = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  background: "#1F2937",
  border: "1px solid #374151",
  borderRadius: 14,
  padding: "16px 18px",
  marginBottom: 10,
  cursor: "pointer",
  textAlign: "left",
  color: "#F9FAFB",
};

export const cardStyle = {
  background: "#1F2937",
  border: "1px solid #374151",
  borderRadius: 14,
  padding: 16,
  marginBottom: 14,
};
